/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const Reward: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="reward" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M749.02 774.9733333333334H972.1733333333332L791.6333333333333 643.7333333333333L860.54 431.4033333333333L680 562.7L499.4033333333334 431.4600000000001L568.3666666666667 643.7900000000001L387.8266666666667 775.03H610.9800000000001L680 987.2466666666666L749.02 774.9733333333334zM1246.6666666666665 997.2766666666666V350.9366666666666L680 27.8233333333333L113.3333333333333 350.9366666666666V997.3333333333331L680 1320.3333333333333L1246.6666666666665 997.22zM226.6666666666667 931.43V416.7833333333334L680 158.3266666666668L1133.3333333333333 416.7833333333334V931.43L680 1190L226.6666666666667 931.43z" : "M599.216 619.9786666666666H777.7386666666666L633.3066666666667 514.9866666666666L688.432 345.1226666666667L544 450.16L399.5226666666668 345.168L454.6933333333334 515.032L310.2613333333335 620.0239999999999H488.7840000000001L544 789.7973333333333L599.216 619.9786666666666zM997.3333333333334 797.8213333333333V280.7493333333332L544 22.2586666666666L90.6666666666667 280.7493333333332V797.8666666666666L544 1056.2666666666667L997.3333333333334 797.776zM181.3333333333334 745.144V333.4266666666666L544 126.6613333333334L906.6666666666669 333.4266666666666V745.144L544 952L181.3333333333334 745.144z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
Reward.displayName = `Blueprint5.Icon.Reward`;
export default Reward;
